import { BookingFormMode } from "PFApp/booking/components/booking_form/booking_form.types";
import { OnSuccessData } from "PFApp/booking/components/booking_form/use_handle_submit/use_handle_submit";
import { DetailsPanelSource, useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { CloneSingleButton } from "PFApp/booking/parts/overview/detail_view/booking_detail/buttons/clone_single_button";
import ButtonGroup from "PFComponents/button_group/button_group";
import { DropdownOption } from "PFComponents/dropdown";
import { DropdownButton } from "PFComponents/dropdown_button";
import { useTranslation } from "react-i18next";

import { useBookingDetailSidePanelContext } from "../booking_detail_side_panel_context";
import css from "./clone_button.module.scss";

type CloneButtonProps = {
  bookingId: number;
  onSuccess: (data: OnSuccessData) => void;
  source?: DetailsPanelSource;
};

export const CloneButton = ({ bookingId, onSuccess, source }: CloneButtonProps) => {
  const { t } = useTranslation("bookingModule");
  const { siblingBookings } = useBookingDetailSidePanelContext();
  const { openBookingFormSidePanel } = useDetailsPanelsActions();
  const isCloneAllAvailable = (siblingBookings?.length ?? 0) > 1;

  const handleClone = (mode: BookingFormMode) =>
    openBookingFormSidePanel({ bookingId }, { onSuccess, mode, source });

  if (!isCloneAllAvailable) {
    return <CloneSingleButton onClick={() => handleClone(BookingFormMode.CloneSingle)} />;
  }

  const options: DropdownOption[] = [
    {
      id: BookingFormMode.CloneAll,
      displayElement: t("bookings.clone.cloneAllBookings"),
      item: BookingFormMode.CloneAll
    }
  ];

  return (
    <ButtonGroup compact autoWidth>
      <CloneSingleButton onClick={() => handleClone(BookingFormMode.CloneSingle)} />
      <DropdownButton
        buttonClassName={css.dropdownButton}
        icon="chevron-down"
        options={options}
        handleChange={(item) => handleClone(item)}
        floatingOptions={{ placement: "bottom-end" }}
        buttonKind="secondary"
      />
    </ButtonGroup>
  );
};
